export class Campaign {
  id: number;
  startingOn: string | Date;
  endingOn: string | Date;

  /**
   * Optional year indicators returned by the API for certain campaigns.
   * They can be provided either as plain numbers (e.g. 2023) or as
   * stringified values, therefore we keep the type as a union.
   *
   * NOTE: TypeScript 1.8 does not allow optional class members, so the
   *       properties are declared without the "?" modifier. They are still
   *       only populated when the backend provides them and therefore can
   *       be `undefined` at runtime.
   */
  campaignYear: string | number;
  year: string | number;

  createdAt: string | Date;
  updatedAt: string | Date;

  static compare(a: Campaign, b: Campaign): number {
    if (a.startingOn < b.startingOn) {
      return -1;
    } else if (a.startingOn > b.startingOn) {
      return 1;
    } else {
      if (a.endingOn < b.endingOn) {
        return -1;
      } else if (a.endingOn > b.endingOn) {
        return 1;
      }
      return 0;
    }
  }
}
